module.exports = __webpack_public_path__ + "static/media/openClassroomsLogo.1923f70f.png";